import type * as React from "react";
import { useState } from "react";

import { BwLogoSymbol } from "@/components/ui/icons";
import { PlaceSwitcherButton } from "./_components/place-switcher-button";
import { PlaceSwitcherDrawer } from "./_components/place-switcher-drawer";
import { UserDropdownMenu } from "./_components/user-dropdown-menu";

export function OnboardingLayout({ children }: { children: React.ReactNode }) {
  const [isPlaceSwitcherOpen, setIsPlaceSwitcherOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-svh">
      <div className="sticky top-0 z-10 backdrop-blur-2xl bg-bg-light-blur shrink-0">
        <header className="flex items-center justify-between h-16 gap-4 px-4 sm:px-6">
          <div className="flex items-center gap-2 min-w-0">
            <BwLogoSymbol className="size-8 shrink-0 text-text-primary" />
            <PlaceSwitcherButton
              //variant="minimal"
              onClick={() => setIsPlaceSwitcherOpen(true)}
              className="shrink min-w-0"
            />
          </div>
          <UserDropdownMenu />
        </header>
      </div>
      <main
        id="my-main-scroll"
        className="flex flex-1 flex-col min-h-0 overflow-hidden bg-bg-light"
      >
        {children}
      </main>
      <PlaceSwitcherDrawer
        open={isPlaceSwitcherOpen}
        onClose={() => setIsPlaceSwitcherOpen(false)}
      />
    </div>
  );
}
